<div class="modal-header">
  <h4 class="modal-title">
    <i class="mdi mdi-alert-circle-outline mr-2"></i>Warning: Session has
    commands pending approval
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="alert alert-warning">
    <p>This session contains submitted commands that are pending approval.</p>
    <p>Are you sure you want to close it?</p>
    <p>Closing this session may result in loss of commands pending approval.</p>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-danger" (click)="confirm()">
    Close Session
  </button>
</div>
